
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import MetaHead from "@/components/MetaHead";

const ImageRedirect = () => {
  const { slug } = useParams<{ slug: string }>();
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [meta, setMeta] = useState({
    title: "",
    description: "",
    url: window.location.href
  });

  // Make sure we're using the full URL with the origin
  const shareUrl = slug ? `${window.location.origin}/img/${slug}` : '';
  
  useEffect(() => {
    if (!slug) return;

    const fetchImageDetails = async () => {
      try {
        // Find image with matching slug
        const { data, error } = await supabase
          .from('images')
          .select('*')
          .eq('slug', slug.replace('.png', ''))
          .single();

        if (error || !data) {
          console.error('Error fetching image data:', error);
          return;
        }

        // Get public URL for the image
        const { data: { publicUrl } } = supabase.storage
          .from('images')
          .getPublicUrl(data.storage_path);

        setImageUrl(publicUrl);
        setMeta({
          title: data.name || "Shared image",
          description: data.description || "View this shared image",
          url: shareUrl
        });
      } catch (error) {
        console.error('Error processing image redirect:', error);
      }
    };

    fetchImageDetails();
  }, [slug, shareUrl]);

  // Handle redirecting to the actual image
  useEffect(() => {
    if (imageUrl) {
      window.location.href = imageUrl;
    }
  }, [imageUrl]);

  return (
    <>
      <MetaHead
        title={meta.title}
        description={meta.description}
        imageUrl={imageUrl || undefined}
        url={meta.url}
      />
      <div className="min-h-screen gradient-bg flex items-center justify-center">
        <div className="p-8 text-center text-white">
          <p>Redirecting to image...</p>
        </div>
      </div>
    </>
  );
};

export default ImageRedirect;
